import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Landmark, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('de-AT') : '–');
const fmtEur = (v) => (v ? new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' }).format(v) : '–');

/** Cockpit-Widget: Mandanten ohne ESt-VZ-Zahlungsanweisung zum nächsten Stichtag (Mail geht 14 Tage vorher automatisch raus). */
export default function LexEvzReminderWidget() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios.get(`${API}/lex/advisor/evz-reminder`).then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || !data.rows) return null;
  const days = Math.ceil((new Date(data.due_date) - new Date()) / 86400000);
  const urgent = days <= 14;

  return (
    <div className="lex-card p-5 mb-6" data-testid="lex-evz-reminder-widget" style={urgent ? { borderLeft: '3px solid #C5A059' } : undefined}>
      <button type="button" onClick={() => setOpen(!open)} className="flex w-full items-center gap-3 text-left" data-testid="lex-evz-reminder-toggle">
        <Landmark className="h-4 w-4 flex-shrink-0" style={{ color: '#C5A059' }} />
        <span className="flex-1 text-sm">
          <span className="text-xs uppercase tracking-widest font-semibold text-slate-500 block">ESt-Vorauszahlung Q{data.quarter}/{data.year} · Stichtag {fmtDate(data.due_date)} · in {days} Tagen</span>
          <span className="text-slate-700" data-testid="lex-evz-reminder-count">
            {data.rows.length === 0 ? 'Alle Mandanten haben eine Zahlungsanweisung mit ESt-VZ.' : `${data.rows.length} Mandanten ohne Zahlungsanweisung mit ESt-VZ`}
            <span className="text-slate-400"> · Erinnerungs-Mail an die Kanzlei am {fmtDate(data.reminder_date)}{data.last_sent ? ` (gesendet ${fmtDate(data.last_sent.sent_at)})` : ''}</span>
          </span>
        </span>
        <ChevronRight className={`h-4 w-4 text-slate-400 transition-transform ${open ? 'rotate-90' : ''}`} />
      </button>
      {open && data.rows.length > 0 && (
        <ul className="mt-4 divide-y divide-slate-100 text-sm" data-testid="lex-evz-reminder-list">
          {data.rows.map((r) => (
            <li key={r.client_id} className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 py-2">
              <Link to={`/kanzlei/mandant/${r.client_id}`} className="font-medium text-slate-800 hover:underline sm:w-56 truncate">{r.name}</Link>
              <span className="lex-mono text-slate-600 sm:w-28 text-right">{fmtEur(r.quarter_amount)}</span>
              <span className="text-xs text-slate-500">{r.hint}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
